if (!customElements.get('shipping-notice')) {
  class ShippingNotice extends HTMLElement {
    connectedCallback() {
      const giftThreshold = this.dataset.gift ? parseInt(this.dataset.gift) : null;
      const shippingThreshold = this.dataset.shipping ? parseInt(this.dataset.shipping) : null;
      
      this.thresholds = [];
      if (giftThreshold !== null) {
        this.thresholds.push({ value: giftThreshold, type: 'gift' });
      }
      if (shippingThreshold !== null) {
        this.thresholds.push({ value: shippingThreshold, type: 'shipping' });
      }
      
      this.thresholds.sort((a, b) => a.value - b.value);
      
      this.cartTotal = parseInt(this.dataset.cartTotal);
      
      requestAnimationFrame(() => this.update());
      
      ['cart:updated', 'cart:refresh'].forEach(e => {
        document.addEventListener(e, evt => {
          const newTotal = evt.detail?.cart?.total_price || evt.detail?.total_price;
          if (newTotal != null) {
            this.cartTotal = parseInt(newTotal);
            this.update();
          }
        });
      });
    }
    
    update() {
      const msgEl = this.querySelector('.shipping-notice__text');
      const bars = this.querySelectorAll('.progress-bar');
      const icons = this.querySelectorAll('.icon-wrapper');
      
      this.thresholds.forEach((threshold, i) => {
        const start = i > 0 ? this.thresholds[i - 1].value : 0;
        const pct = Math.min(100, Math.max(0, ((this.cartTotal - start) / (threshold.value - start)) * 100));
        
        const bar = Array.from(bars).find((b, idx) => {
          const segment = b.closest('.progress-segment');
          return segment && segment.dataset.type === threshold.type;
        });
        const icon = Array.from(icons).find(ic => ic.dataset.type === threshold.type);
        
        if (bar) bar.style.width = pct + '%';
        if (icon) icon.classList.toggle('active', this.cartTotal >= threshold.value);
      });
      
      const msgs = [];
      const nextIndex = this.thresholds.findIndex(t => this.cartTotal < t.value);
      const hasOnlyGift = this.dataset.gift && !this.dataset.shipping;
      const hasOnlyShipping = this.dataset.shipping && !this.dataset.gift;

      if (nextIndex > 0) {
        for (let i = 0; i < nextIndex; i++) {
          const achievedType = this.thresholds[i].type;
          msgs.push(achievedType === 'gift' ? this.dataset.giftAchieved : this.dataset.shippingAchieved);
        }
      }

      if (nextIndex >= 0) {
        const nextThreshold = this.thresholds[nextIndex];
        const remaining = nextThreshold.value - this.cartTotal;
        const formatted = typeof Shopify !== 'undefined' && Shopify.formatMoney 
          ? Shopify.formatMoney(remaining, this.dataset.moneyFormat)
          : new Intl.NumberFormat(this.dataset.locale, {style:'currency',currency:this.dataset.currency,minimumFractionDigits:0,maximumFractionDigits:0}).format(remaining / 100);
        msgs.push((nextThreshold.type === 'gift' ? this.dataset.giftRemaining : this.dataset.shippingRemaining).replace('{amount}', formatted));
      } else if (this.thresholds.length > 0 && this.cartTotal >= this.thresholds[this.thresholds.length - 1].value) {

        if (hasOnlyGift) {
          msgs.push(this.dataset.giftAchieved);
        } else if (hasOnlyShipping) {
          msgs.push(this.dataset.shippingAchieved);
        } else {
          msgs.push(this.dataset.allAchieved);
        }
      }
      
      if (msgEl) msgEl.innerHTML = msgs.join('<br>');
    }
  }
  customElements.define('shipping-notice', ShippingNotice);
}

